(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/button"), require("@splat/constant"), require("@splat/theme"), require("core-js/modules/esnext.global-this.js"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define([, , , "core-js/modules/esnext.global-this.js", , , , , ], factory);
	else if(typeof exports === 'object')
		exports["dialog"] = factory(require("@splat/button"), require("@splat/constant"), require("@splat/theme"), require("core-js/modules/esnext.global-this.js"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["dialog"] = factory(root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_button__, __WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    dialog: {
      cancel: 'Cancel',
      confirm: 'Ok',
      loading: 'Loading'
    }
  },
  'zh-CHT': {
    dialog: {
      cancel: "\u53D6\u6D88",
      confirm: "\u78BA\u5B9A",
      loading: "\u52A0\u8F09\u4E2D"
    }
  },
  'zh-CN': {
    dialog: {
      cancel: "\u53D6\u6D88",
      confirm: "\u786E\u5B9A",
      loading: "\u52A0\u8F7D\u4E2D"
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dialogWrapperClassName": function() { return /* binding */ dialogWrapperClassName; },
/* harmony export */   "dialogContainerClassName": function() { return /* binding */ dialogContainerClassName; },
/* harmony export */   "dialogHeaderClassName": function() { return /* binding */ dialogHeaderClassName; },
/* harmony export */   "dialogTitleClassName": function() { return /* binding */ dialogTitleClassName; },
/* harmony export */   "dialogBodyClassName": function() { return /* binding */ dialogBodyClassName; },
/* harmony export */   "dialogFooterClassName": function() { return /* binding */ dialogFooterClassName; },
/* harmony export */   "dialogCloseButtonClassName": function() { return /* binding */ dialogCloseButtonClassName; },
/* harmony export */   "dialogCloseButtonDisabledClassName": function() { return /* binding */ dialogCloseButtonDisabledClassName; },
/* harmony export */   "dialogDefaultFooterClassName": function() { return /* binding */ dialogDefaultFooterClassName; },
/* harmony export */   "dialogDefaultFooterExtraClassName": function() { return /* binding */ dialogDefaultFooterExtraClassName; },
/* harmony export */   "dialogDefaultFooterSubmitClassName": function() { return /* binding */ dialogDefaultFooterSubmitClassName; },
/* harmony export */   "dialogFadeTransitionName": function() { return /* binding */ dialogFadeTransitionName; },
/* harmony export */   "fadeInKeyFrames": function() { return /* binding */ fadeInKeyFrames; },
/* harmony export */   "fadeOutKeyFrames": function() { return /* binding */ fadeOutKeyFrames; },
/* harmony export */   "buttonClassName": function() { return /* binding */ buttonClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);





var dialogWrapperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0), {
  position: 'fixed',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  overflow: 'auto',
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogColors.mask.toString(),
  zIndex: 11
});
var dialogContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.bodyPaddingSize), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.bodyPaddingSize)), csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.vertical, csstips__WEBPACK_IMPORTED_MODULE_2__.attachToRight, {
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogColors.containerBackground.toString(),
  boxShadow: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.dialogBoxShadow,
  boxSizing: 'content-box',
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(50),
  maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.maxWidth),
  overflow: 'auto'
});
var dialogHeaderClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center, csstips__WEBPACK_IMPORTED_MODULE_2__.betweenJustified, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.headerTopPadding), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.headerBottomPadding), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0)), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.headerTopMargin), 0, 0, 0), {
  boxSizing: 'border-box',
  borderBottom: (0,csx__WEBPACK_IMPORTED_MODULE_3__.border)({
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogColors.headerBorder.toString(),
    style: 'solid',
    width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
  }),
  minHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(43),
  position: ['relative', '-webkit-sticky', 'sticky'],
  top: 0,
  zIndex: 1,
  background: 'white'
});
var dialogTitleClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.titleFontSize),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.titleFontLineHeight),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogColors.titleFont.toString()
});
var dialogBodyClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-88), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0)), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(88), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0)), csstips__WEBPACK_IMPORTED_MODULE_2__.flex, {
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogColors.bodyFont.toString(),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.bodyFontSize)
});
var dialogFooterClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.footerTopPadding), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(32), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0)), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0), {
  textAlign: 'right',
  boxSizing: 'border-box',
  position: ['relative', '-webkit-sticky', 'sticky'],
  bottom: 0,
  zIndex: 1,
  background: 'white'
});
var dialogCloseButtonClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0), {
  cursor: 'pointer',
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.DialogSizes.closeSize),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.regularText.toString(),
  $nest: {
    '&:hover, &:focus': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primaryText.toString()
    }
  }
});
var dialogCloseButtonDisabledClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(dialogCloseButtonClassName, ", &.").concat(dialogCloseButtonClassName, ":hover, &.").concat(dialogCloseButtonClassName, ":focus"), {
    cursor: 'not-allowed',
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.normalText.toString()
  })
});
var dialogDefaultFooterClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.betweenJustified, {
  flexDirection: 'row-reverse'
});
var dialogDefaultFooterExtraClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.content, {});
var dialogDefaultFooterSubmitClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.content, {});
var dialogFadeTransitionName = 'dialog-fade';
var fadeInKeyFrames = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.keyframes)({
  '0%': {
    marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(-100),
    opacity: 0.5
  },
  '100%': {
    marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(0),
    opacity: 1
  }
});
var fadeOutKeyFrames = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.keyframes)({
  '0%': {
    marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(0),
    opacity: 1
  },
  '100%': {
    marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(-100),
    opacity: 0.5
  }
});
(0,typestyle__WEBPACK_IMPORTED_MODULE_4__.cssRule)(".".concat(dialogFadeTransitionName, "-enter-active"), {
  animation: fadeInKeyFrames,
  animationDuration: '.3s'
});
(0,typestyle__WEBPACK_IMPORTED_MODULE_4__.cssRule)(".".concat(dialogFadeTransitionName, "-leave-active"), {
  animation: fadeOutKeyFrames,
  animationDuration: '.3s'
});
var buttonClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24))
});

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/button":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/button","commonjs2":"@splat/button"} ***!
  \*************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_button__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dialogFadeTransitionName": function() { return /* reexport safe */ _style__WEBPACK_IMPORTED_MODULE_12__.dialogFadeTransitionName; },
/* harmony export */   "DialogStyles": function() { return /* binding */ DialogStyles; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/button */ "@splat/button");
/* harmony import */ var _splat_button__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_button__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_17__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var Dialog = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Dialog, _tsx$Component);

  var _super = _createSuper(Dialog);

  function Dialog() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "title", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "submitting", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "confirmButtonText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "confirmButtonLoadingText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "cancelButtonText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showClose", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "showCancel", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "closeOnClickModal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "beforeOk", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "maskOnSubmitting", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "maxWidth", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_11__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "beforeOkRunning", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Dialog, [{
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }
    }
  }, {
    key: "maxWidthClass",
    get: function get() {
      return (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.style)({
        maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_17__.important)("".concat(this.maxWidth, "px"))
      });
    }
  }, {
    key: "loading",
    get: function get() {
      return this.submitting || this.beforeOkRunning;
    }
  }, {
    key: "confirmButton",
    get: function get() {
      return this.confirmButtonText || this.i18n.t.dialog.confirm;
    }
  }, {
    key: "confirmButtonLoading",
    get: function get() {
      return this.confirmButtonLoadingText || this.i18n.t.dialog.loading;
    }
  }, {
    key: "cancelButton",
    get: function get() {
      return this.cancelButtonText || this.i18n.t.dialog.cancel;
    }
  }, {
    key: "onInput",
    value: function onInput(v) {
      return v;
    }
  }, {
    key: "onOpen",
    value: function onOpen() {}
  }, {
    key: "onClose",
    value: function onClose() {}
  }, {
    key: "onOk",
    value: function onOk() {}
  }, {
    key: "onCancel",
    value: function onCancel() {}
  }, {
    key: "handleOk",
    value: function handleOk() {
      var _this2 = this;

      if (this.beforeOk) {
        this.beforeOkRunning = true;
        var result = this.beforeOk();

        if (result) {
          return result.then(function () {
            _this2.onOk();

            _this2.beforeOkRunning = false;
          }).catch(function () {
            _this2.beforeOkRunning = false;
          });
        }

        this.beforeOkRunning = false;
      }

      this.onOk();
    }
  }, {
    key: "handleValueChanged",
    value: function handleValueChanged(v) {
      if (v) {
        this.onOpen();
      } else {
        this.onClose();
      }
    }
  }, {
    key: "handleWrapperClick",
    value: function handleWrapperClick() {
      if (this.closeOnClickModal) {
        this.handleClose();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onInput(false);
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value,
          title = this.title,
          showClose = this.showClose,
          showCancel = this.showCancel,
          loading = this.loading,
          confirmButton = this.confirmButton,
          confirmButtonLoading = this.confirmButtonLoading,
          cancelButton = this.cancelButton,
          handleClose = this.handleClose,
          handleOk = this.handleOk,
          handleWrapperClick = this.handleWrapperClick,
          maskOnSubmitting = this.maskOnSubmitting,
          maxWidth = this.maxWidth,
          maxWidthClass = this.maxWidthClass,
          theme = this.theme;
      return h("transition", {
        "attrs": {
          "name": _style__WEBPACK_IMPORTED_MODULE_12__.dialogFadeTransitionName
        }
      }, [value ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.dialogWrapperClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'wrapper')),
        "on": {
          "click": handleWrapperClick
        }
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.dialogContainerClassName, !!maxWidth && maxWidthClass, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'container')),
        "on": {
          "click": (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.eventStop)()
        }
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.dialogHeaderClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'header'))
      }, [this.$slots.title || h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.dialogTitleClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'title'))
      }, [title]), showClose ? h("i", {
        "on": {
          "click": function click() {
            return loading ? null : handleClose();
          }
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)('el-icon-close', _style__WEBPACK_IMPORTED_MODULE_12__.dialogCloseButtonClassName, loading && _style__WEBPACK_IMPORTED_MODULE_12__.dialogCloseButtonDisabledClassName)
      }) : null]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.dialogBodyClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'body')),
        "directives": [{
          name: "loading",
          value: maskOnSubmitting && loading
        }]
      }, [this.$slots.default]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.dialogFooterClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'footer'))
      }, [this.$slots.footer || h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_12__.dialogDefaultFooterClassName
      }, [h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_12__.dialogDefaultFooterSubmitClassName
      }, [showCancel ? h((_splat_button__WEBPACK_IMPORTED_MODULE_8___default()), {
        "attrs": {
          "small": theme === _splat_constant__WEBPACK_IMPORTED_MODULE_9__.ThemeType.Cloud || theme === _splat_constant__WEBPACK_IMPORTED_MODULE_9__.ThemeType.Aliyun,
          "disabled": loading
        },
        "on": {
          "click": this.onCancel
        }
      }, [cancelButton]) : null, h((_splat_button__WEBPACK_IMPORTED_MODULE_8___default()), {
        "attrs": {
          "small": theme === _splat_constant__WEBPACK_IMPORTED_MODULE_9__.ThemeType.Cloud || theme === _splat_constant__WEBPACK_IMPORTED_MODULE_9__.ThemeType.Aliyun,
          "type": _splat_button__WEBPACK_IMPORTED_MODULE_8__.Type.primary,
          "loading": loading
        },
        "on": {
          "click": handleOk
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(showCancel && _style__WEBPACK_IMPORTED_MODULE_12__.buttonClassName, showCancel && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_9__.createSplatClassName)('dialog', 'cancel_button'))
      }, [loading ? confirmButtonLoading : confirmButton])]), this.$slots.extra ? h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_12__.dialogDefaultFooterExtraClassName
      }, [this.$slots.extra]) : null])])])]) : null]);
    }
  }]);

  return Dialog;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_15__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "title", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "submitting", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "confirmButtonText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "confirmButtonLoadingText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "cancelButtonText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)({
  default: true
})], Dialog.prototype, "showClose", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)({
  default: true
})], Dialog.prototype, "showCancel", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)({
  default: false
})], Dialog.prototype, "closeOnClickModal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "beforeOk", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "maskOnSubmitting", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], Dialog.prototype, "maxWidth", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Inject)({
  from: 'i18nInjection',
  default: null
})], Dialog.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Provide)('i18nInjection')], Dialog.prototype, "i18nProvider", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('input')], Dialog.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('open')], Dialog.prototype, "onOpen", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('close')], Dialog.prototype, "onClose", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('ok')], Dialog.prototype, "onOk", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('cancel')], Dialog.prototype, "onCancel", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Watch)('value')], Dialog.prototype, "handleValueChanged", null);

Dialog = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_10___default())]
})], Dialog);
/* harmony default export */ __webpack_exports__["default"] = (Dialog);

var DialogStyles = _style__WEBPACK_IMPORTED_MODULE_12__;
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map